import React, {useState} from "react";
import {useSearchParams} from "react-router-dom";

import Layout from "antd/lib/layout/layout";
import {Contain} from "@components/layout";
import SearchPageIssues from "./issues/SearchPageIssues";
import SearchPageSeries from "./series/SearchPageSeries";
import {getIsIssueNumberInQueryString} from "@lib/utils";
import {TopnavSearchDropdown} from "@components/topnav-search-dropdown";
import SomethingMissing from "@components/something-missing";

const SearchPage = () => {
    const [searchParams] = useSearchParams();
    const isSearchBarcode = searchParams.has("search") && (searchParams.get("search") || "").length > 10 && /^\d+$/.test((searchParams.get("search") || ""));
    const [query, setQuery] = useState(String(searchParams.has("search") ? searchParams.get("search") : ""));
    const searchingIssues = getIsIssueNumberInQueryString(query) || isSearchBarcode;

    return (
    <>
        <TopnavSearchDropdown query={query} isOnPage={true} />
        <Layout className="page search-page">
            <Contain>
                {searchingIssues ? (
                    <SearchPageIssues query={query} setQuery={setQuery} isSearchBarcode={isSearchBarcode} />
                ) : (
                    <div className={"search-page-series"}>
                        <SearchPageSeries query={query} setQuery={setQuery}/>
                    </div>
                )}

                <SomethingMissing/>
            </Contain>
        </Layout>
    </>
    );
};

export default SearchPage;